import React from 'react';
import {
    Box,
    Typography,
    Link,
    useTheme,
    ThemeProvider,
    Stack,
    Divider,
} from '@mui/material';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer = () => {
    const theme = useTheme();
    const iconFontSize = 40;
    const links = [
        {
            href: 'https://www.youtube.com/@renewedmindcoach',
            icon: <YouTubeIcon sx={{ fontSize: iconFontSize }} />,
        },
        {
            href: 'https://www.facebook.com/people/Renewed-Mind-Coaching-LLC/61567702154548/',
            icon: <FacebookIcon sx={{ fontSize: iconFontSize }} />,
        },
        {
            href: 'https://www.instagram.com/renewedmindcoach/',
            icon: <InstagramIcon sx={{ fontSize: iconFontSize }} />,
        },
    ];

    return (
        <ThemeProvider theme={theme}>
            <Box textAlign="center" p={4}>
                <Typography variant="body1" color="textSecondary">
                    Follow us on
                    <br />
                    {links.map((link, index) => (
                        <Link
                            key={index}
                            href={link.href}
                            target="_blank"
                            px={1}
                            color="textSecondary"
                        >
                            {link.icon}
                        </Link>
                    ))}
                </Typography>
                <Stack
                    direction="row"
                    spacing={2}
                    divider={<Divider orientation="vertical" flexItem />}
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <a href="/PrivacyPolicy">Privacy Policy</a>
                    <a href="/TermsAndConditions">Terms And Conditions</a>
                </Stack>
            </Box>
        </ThemeProvider>
    );
};

export default Footer;
